import { ref, unref, watch } from '@vue/composition-api'
import SlaTipoAlertaEnum from '@/models/entities/sla/SlaTipoAlertaEnum'
import FilaService from '@/services/modules/FilaService'

function getChips() {
  return {
    primeiraRespostaBadgeAzul: {
      value: SlaTipoAlertaEnum.Azul,
      text: '0',
    },
    primeiraRespostaBadgeVerde: {
      value: SlaTipoAlertaEnum.Verde,
      text: '0',
    },
    primeiraRespostaBadgeLaranja: {
      value: SlaTipoAlertaEnum.Laranja,
      text: '0',
    },
    primeiraRespostaBadgeVermelho: {
      value: SlaTipoAlertaEnum.Vermelho,
      text: '0',
    },
    finalizacaoBadgeAzul: {
      value: SlaTipoAlertaEnum.Azul,
      text: '0',
    },
    finalizacaoBadgeVerde: {
      value: SlaTipoAlertaEnum.Verde,
      text: '0',
    },
    finalizacaoBadgeLaranja: {
      value: SlaTipoAlertaEnum.Laranja,
      text: '0',
    },
    finalizacaoBadgeVermelho: {
      value: SlaTipoAlertaEnum.Vermelho,
      text: '0',
    },
  }
}

export default function useTicketListSlasContadores(filaId, atendenteId) {
  const slasContadores = ref(getChips())

  async function setSlasContadores() {
    const estatisticas = await FilaService.getFilaSlas(unref(filaId), unref(atendenteId))

    slasContadores.value.primeiraRespostaBadgeAzul.text = estatisticas.qtdSlaPrimeiraRespostaTicketAlertaAzul.toString()
    slasContadores.value.primeiraRespostaBadgeVerde.text = estatisticas.qtdSlaPrimeiraRespostaTicketAlertaVerde.toString()
    slasContadores.value.primeiraRespostaBadgeLaranja.text = estatisticas.qtdSlaPrimeiraRespostaTicketAlertaLaranja.toString()
    slasContadores.value.primeiraRespostaBadgeVermelho.text = estatisticas.qtdSlaPrimeiraRespostaTicketAlertaVermelho.toString()

    slasContadores.value.finalizacaoBadgeAzul.text = estatisticas.qtdSlaFinalizacaoTicketAlertaAzul.toString()
    slasContadores.value.finalizacaoBadgeVerde.text = estatisticas.qtdSlaFinalizacaoTicketAlertaVerde.toString()
    slasContadores.value.finalizacaoBadgeLaranja.text = estatisticas.qtdSlaFinalizacaoTicketAlertaLaranja.toString()
    slasContadores.value.finalizacaoBadgeVermelho.text = estatisticas.qtdSlaFinalizacaoTicketAlertaVermelho.toString()
  }

  async function refetchSlasContadores() {
    await setSlasContadores()
  }

  watch(
    () => [unref(filaId), unref(atendenteId)],
    async () => {
      await setSlasContadores()
    },
    { immediate: true },
  )

  return {
    slasContadores,
    refetchSlasContadores,
  }
}
